import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ONBOARDING_KEY } from "../../../api/queryKeys";

export interface EligibilityItemsInterface {
  eligibility_employees_contractor: string;
  eligibility_pay_type: string;
  eligibility_executives: string;
}

export interface ProgramItemsInterface {
  id?: number;
  budget?: string | null;
  ygbm_goal?: string;
  ygbm_reward?: string;
  ygbm_monthly_max_contrib?: string;
  no_spend_monthly_match_bonus?: string;
  default_contrib_amount?: string;
  sign_up_bonus_amount?: string;
  referral_bonus_amount?: string;
  offer_debit_card?: boolean;
  send_debit_card_by_default?: boolean;
  adoption_send_emails?: boolean;
  adoption_send_texts?: boolean;
  adoption_send_flyers?: boolean;
  adoption_custom_images?: boolean;
  adoption_include_spanish?: boolean;
  adoption_tifin_responsible?: boolean;
  [key: string]: any;
}

interface SaveOnboardingMutationBodyI {
  employerItems?: {
    name?: string;
    total_number_of_employees?: string;
    phone_number?: string;
    payroll_system?: string;
    logo?: any;
  };
  eligibilityItems?: EligibilityItemsInterface;
  programItems?: ProgramItemsInterface;
  default_program_values?: boolean;
}

async function saveOnboarding({
  employerItems,
  eligibilityItems,
  programItems,
  default_program_values = false,
}: SaveOnboardingMutationBodyI) {
  return api
    .put(QUERY_ONBOARDING_KEY, {
      employer_items: employerItems,
      eligibility_items: eligibilityItems,
      program_items: programItems,
      default_program_values: default_program_values,
    })
    .then((res) => res.data);
}

export default function useSaveOnboarding({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  const queryClient = useQueryClient();
  return useMutation(saveOnboarding, {
    onError: (error: AxiosError) => {
      const message = (error.response?.data as any).error;
      if (error && message) {
        toast.error(message);
      } else {
        toast.error("We were unable to save the program. Please try again.");
      }
    },
    onSuccess: (data) => {
      queryClient.refetchQueries([QUERY_ONBOARDING_KEY]);

      if (onSuccessHandler) {
        onSuccessHandler();
      }
    },
  });
}
